'use strict';

import React, { Component } from 'react';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import moment from 'moment';
import numeral from 'numeral';
import uniqid from 'uniqid';
import Loader from 'Pure/Loader';
import scrollToNode from 'Functions/scrollToNode';
import bemit from 'Functions/bemit';
import { MAPS_API_KEY } from 'front_env';
moment.locale('fr');
numeral.locale('en');
const app = window.app;
const PIN_SIZE = window.innerWidth < 600 ? 64 : 48;
const CLUSTER_PIN_SIZE = 44;
const cluster_styles = [{
  width: CLUSTER_PIN_SIZE,
  height: CLUSTER_PIN_SIZE,
  className: bemit('c-cluster-icon', ['blue'])
}, {
  width: CLUSTER_PIN_SIZE,
  height: CLUSTER_PIN_SIZE,
  className: bemit('c-cluster-icon', ['blue'])
}, {
  width: CLUSTER_PIN_SIZE,
  height: CLUSTER_PIN_SIZE,
  className: bemit('c-cluster-icon', ['blue'])
}];
export default class SearchResultsMap extends Component {
  state = {
    gmap_id: uniqid(),
    script_id: 'google-map-script',
    script_ready: false
  };
  _init = false;
  map_ref = React.createRef();
  markers = [];
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'UpdateSearchResultsMap',
      cb: component.updateMap
    });
    app.push({
      event: 'ResetSearchResultsMap',
      cb: component.resetMap
    });
    component.loadScriptIfNeeded();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'UpdateSearchResultsMap',
      cb: component.updateMap
    });
    app.delete({
      event: 'ResetSearchResultsMap',
      cb: component.resetMap
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_state.script_ready !== true && state.script_ready === true) {
      component.startMapIfNeeded();
    } else if (props['search-id'] !== prev_props['search-id']) {
      component.startMapIfNeeded();
    }
  }
  resetMap = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.placeMarkers(props.etablishments, true);
  };
  updateMap = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const etablishments = data.etablishments || [];
    component.placeMarkers(etablishments, true);
    if (etablishments.length && props['auto-scroll'] && component.map_ref?.current) {
      const is__visible = component.map_ref.current.getBoundingClientRect?.()?.top > 0;
      if (!is__visible) {
        component.map_ref?.current?.parentElement?.scrollIntoView?.({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  loadScriptIfNeeded = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Script already appended and loaded
    if (window.google?.maps?.Map) {
      return component.setState({
        script_ready: true
      });
    }
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('async', true);
    script.setAttribute('defer', true);
    script.setAttribute('id', state.script_id);
    script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + MAPS_API_KEY);
    script.addEventListener('load', function () {
      component.setState({
        script_ready: true
      });
    });
    script.addEventListener('onError', function (e, error) {
      console.error('error loading gmap', error);
    });
    document.body.appendChild(script);
  };
  startMapIfNeeded = (force = false) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!window.google?.maps?.Map) return;
    const map_div = document.getElementById('gmap-' + component.state.gmap_id);
    component.map = new window.google.maps.Map(map_div, {
      zoom: 6,
      center: {
        lat: 46.5674172,
        lng: 1.4753071
      },
      // France
      gestureHandling: 'cooperative'
    });
    component.placeMarkers(props.etablishments);
    if (typeof props.onMove === 'function') {
      component.map.addListener('bounds_changed', component.handleMapMoved);
    }
  };
  placeMarkers = (etablishments, reset_if_no_results = false) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component.map || !window.google.maps) return;
    if (component.cluster) {
      component.cluster.clearMarkers();
      component.markers = [];
    }
    const bounds = new window.google.maps.LatLngBounds();
    (etablishments || []).forEach(function (etablishment) {
      let marker = component.markers[etablishment.id],
        id = etablishment.id;
      const is__invalid = !etablishment?.geometry?.location?.lat || !etablishment?.geometry?.location?.lng;
      if (is__invalid) {
        return console.error('Invalid marker position', etablishment);
      }
      const position = new window.google.maps.LatLng(etablishment.geometry.location.lat, etablishment.geometry.location.lng);
      marker = {
        visible: true,
        marker: new window.google.maps.Marker({
          position: position,
          map: component.map,
          title: etablishment.name,
          icon: {
            url: '/images/map_pin.svg',
            scaledSize: new window.google.maps.Size(PIN_SIZE, PIN_SIZE) // pixels
          }
        })
      };

      bounds.extend(position);

      // Toggle off a marker :
      // marker.visible = false;
      // marker.marker.setMap(null);

      // Toggle on a marker :
      // marker.visible = true;
      // marker.marker.setMap(component.map);

      if (!marker.tooltips) {
        let tooltip = {
          open: false
        };
        let content = '<div class="c-gmap__tooltip">' + etablishment.name + '</div>';
        tooltip.infowindow = new window.google.maps.InfoWindow({
          content: content
        });
        marker.tooltips = [tooltip];
        if (!component.markers[id]) {
          marker.marker.addListener('click', function () {
            let global_tooltip = marker.tooltips[0];
            if (props['disable-tooltip'] !== true) {
              global_tooltip.infowindow.open(component.map, component.markers[id].marker);
            }
            app.emit({
              event: 'clickedMapEtablishment',
              source: 'SearchResultsMap.placeMarkers',
              data: {
                etablishment: etablishment
              }
            });
          });
        }
      }
      component.markers[id] = marker;
    });
    if (etablishments?.length > 0) {
      component.map.fitBounds(bounds);
      window.setTimeout(function () {
        if (component.map && component.map.getZoom() > 15) {
          component.map.setZoom(15);
        } else {
          component.map.setZoom(component.map.getZoom() - 1);
        }
        const map_node = props['search-id'] ? document.getElementById('gmap-' + state.gmap_id) : undefined;
        if (!map_node) return;
        const rect = map_node.getBoundingClientRect();
        if (rect.height < window.innerHeight && rect.bottom > window.innerHeight) {
          const missing = rect.bottom - window.innerHeight;
          const scrolled = document.scrollingElement.scrollTop;
          document.scrollingElement.scrollTo({
            top: scrolled + missing,
            behavior: 'smooth'
          });
        }
      }, 300);
    } else if (etablishments?.length === 0 && reset_if_no_results) {
      component.setDefaultView(bounds);
    }
    const markers = Object.keys(component.markers).map(id => component.markers[id].marker).filter(marker => marker !== undefined);
    component.cluster = new MarkerClusterer(component.map, markers, {
      gridSize: 40,
      styles: cluster_styles
    });
  };
  setDefaultView = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const position = props.user_location ? new window.google.maps.LatLng(props.user_location.latitude, props.user_location.longitude) : new window.google.maps.LatLng('46.00', '2.00'); // France

    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(position);
    component.map.fitBounds(bounds);
  };
  handleMapMoved = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component._init) {
      component._init = true;
      return;
    }

    // évite d'appeler 15 fois la fonction par frame
    if (component._ticking) return;
    component._ticking = true;
    window.requestAnimationFrame(function () {
      component._ticking = false;
      props.onMove(component.map.getBounds().toJSON());
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    let modifiers = (props.bemit || []).slice(0);
    if (props.home === true) {
      modifiers.push('home');
    } else {
      modifiers.push('search-results');
    }
    return /*#__PURE__*/React.createElement("div", {
      className: bemit('c-gmap', modifiers),
      id: 'gmap-' + state.gmap_id,
      key: props['search-id'],
      ref: component.map_ref
    }, loader);
  }
}
